module.exports = __webpack_public_path__ + "static/img/chart.15fe45db.svg";